export default {
  id: 'about',
  navTitleID: 'about.navTitle',
  pages: [
    {
      id: 'page-1',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textLayout: 'inverse',
          textID: 'text'
        }
      ]
    }
  ]
}
